import axios from 'axios'

const instance = axios.create({
  timeout: 60000
})

// 添加请求拦截器
instance.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {
      config.headers['x-auth-token'] = localStorage.getItem('token')
    }
    return config
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    const { data } = response
    const { code, message } = data
    if (message.includes('内部错误')) {
      response.data.message = '服务异常，请稍后再试'
    }
    if (code) {
      if (code === '200' || code === 200 || code === '0' || code === 0) {
        return data
      } else {
        return Promise.reject(data)
      }
    } else {
      return data
    }
  },
  error => {
    if (error.response) {
      if (error.response.status === 460) {
        setTimeout(() => {
          location.hash = '/'
        }, 500)
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ message: '登录失效，请重新登录' })
      }
      if (error.response.status === 401) {
        setTimeout(() => {
          location.hash = '/'
        }, 500)
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ message: '登录超时，请重新登录' })
      }
      if (error.response.status === 502) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({ message: '网络错误，请检查网络后重试' })
      }
      return Promise.reject(error.response.data)
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({ message: '网络错误，请检查网络后重试' })
  }
)

/**
 * axios请求
 * @param {*} method 请求方式
 * @param {*} url 请求地址
 * @param {*} params 参数
 * @param {*} headers 请求头设置
 */
function sendHttp (method = 'get', url = '', params = {}, headers = {}) {
  method = method.toLowerCase()
  url = `${localStorage.getItem('apiRoot')}/hesiCloud${url}`
  params = (method === 'get' || method === 'delete') ? {params} : params
  return new Promise((resolve, reject) => {
    try {
      instance[method](url, params, headers).then(res => {
        resolve(res)
      }, error => {
        reject(error)
      })
    } catch (error) {
      reject(error)
    }
  })
}

export { sendHttp }



// WEBPACK FOOTER //
// ./src/assets/js/request.js